import React from "react"

export default function CustomTabs({ tabs, activeTab, onTabClick }: { tabs: Array<{ label: string; count?: number; icon: JSX.Element }>; activeTab: string; onTabClick: (label: string) => void }) {
  return (
    <div className="flex gap-2 px-2 py-2">
      {tabs.map((tab) => (
        <div
          key={tab.label}
          className={
            "flex items-center px-2 py-1 rounded-md cursor-pointer text-sm transition " +
            (activeTab === tab.label
              ? "border border-gray-300 text-gray-900 font-medium bg-white"
              : "text-gray-400 bg-transparent")
          }
          onClick={() => onTabClick(tab.label)}
        >
          <span className="mr-1 flex items-center">{tab.icon}</span>
          <span>{tab.label}</span>
          {typeof tab.count === "number" && (
            <span className="ml-2 text-[10px] text-gray-400">{tab.count}</span>
          )}
        </div>
      ))}
    </div>
  )
}

